export default{
//	 baseURL:'http://192.168.1.103:8082/', //168
//	baseURL:'http://192.168.1.192:8080/api',   //陈勇
//  baseURL:'http://110.cs.gc80.cn',   //陈勇
 	 baseURL:'https://m-zzjy.ahharc.com/api',      //正式
	// baseURL:'http://weixin.ahsjxjy.com/api',         //微信支付测试
	method:'POST',
	headers: {'Content-Type':'application/x-www-form-urlencoded'},
	transformRequest: [
	    function(data) {
	      	let ret = ''
	      	for (let it in data) {
	        	ret += encodeURIComponent(it) +
	          	'=' +
	          	encodeURIComponent(data[it]) +
	          	'&'
	      	}
	      	return ret
	    }
	],
	timeout: 20000
}



// WEBPACK FOOTER //
// ./src/api/base.js